import React from 'react';
import styles from '../WifiConnect.module.scss';
import { AppConfig } from '../../../constants/config';

export const WarningMessage: React.FC = () => {
  return AppConfig.showWarningMessage ? (
    <div className={styles.notification}>
      Planned maintenance on <strong>Saturday May 17 from 9am - 3pm ET</strong>.{' '}
      Brief intermittent connectivity issues to the WeWorkWiFi and WeWorkDevice
      wireless networks should be expected. While this website remains
      operational during this time, no changes will be allowed.
      <br />
      <br />
      If you encounter a &quot;Cannot join or connect to WiFi&quot; error
      message, you can forget the network and connect back to WeWorkWiFi. If you
      continue to experience any WiFi issues after this update, please submit a
      support request via the WeWork App.
    </div>
  ) : (
    <></>
  );
};
